/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const Q_who_closer = require('./Q_who_closer');
const BattleCalc = require('../../BattleCalc');

const Q_tank_between_ally_and_menacer = function (
  actor,
  battleState,
  aggroNode,
  moveTowards
) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = aggroNode;
  node.branches[node.NO] = new Q_who_closer(
    actor,
    battleState,
    aggroNode,
    moveTowards
  );

  node.query = function (ally) {
    // input should be the nearest injured ally
    const hero_menacers_only =
      actor.hero && !actor.poppet && !battleState.isCaverns;
    const menacer = this.battleState.getNearestEnemyOf(
      ally,
      hero_menacers_only
    );
    var hurtAllyAndMenacer = [ally, menacer];

    if (this.yesNoEvalFunction(hurtAllyAndMenacer)) {
      return this.branches[this.YES].query();
    } else {
      return this.branches[this.NO].query(hurtAllyAndMenacer);
    }
  };

  node.yesNoEvalFunction = function (hurtAllyAndMenacer) {
    var allies = BattleCalc.getAlliesOfUnit(
      this.actor,
      this.battleState.allUnits,
      true
    );

    for (const ally of allies) {
      if (
        (ally?.ai?.priorities[0] === 'tank' ||
          ally?.ai?.priorities[1] === 'tank') &&
        BattleCalc.pieceIsBetweenPair(ally, hurtAllyAndMenacer)
      ) {
        return true;
      }
    }

    return false;
  };

  return node;
};
module.exports = Q_tank_between_ally_and_menacer;
